import { WatcherType } from "../types/watcherType"

export const watcherAppModality = (props: WatcherType) => {
    const { watcher, currentStep, fields, getValues } = props;
    let process = [...fields];
    const isNotCCId = getValues("idNumType") !== "CO1C"
    process = process.map((section, idx) => {
        if(section.idContentful === "1g5hsAWVwXwKgo89rhPYLT"){
            let fields = [
                ...section?.fields.map((field: any) => {
                    if (field.name === "secondName" || field.name === "secondLastName") {
                        return { ...field, required: false}
                    } else if(field.name === "expeditionDate" && isNotCCId){
                        return { ...field, disabled: false }
                    }
                    return field;
                }),
            ];
            return { ...section, fields  }
        }
        if(section.idContentful === "6maxdWTbIgpLFmMsh2s8ov"){
            let fields = [
                ...section?.fields.map((field: any) => {
                    if (
                        field.name === "finishedLaborCertificateFileTemp"
                    ) {
                        return { ...field, label: watcher === "I" ? "Certificado de cesación de ingresos" : "Certificado de terminación laboral" }
                    }
                    return field;
                }),
            ];
            return { ...section, fields  }
        }
        if (!section.fields || idx !== currentStep) return section;
        let fields = [
            ...section?.fields.map((field: any) => {
                if (
                    field.name === "laborRelationship" ||
                    field.name === "independentType"
                ) {
                    return { ...field, hidden: true };
                }
                return field;
            }),
        ];

        if (watcher === "I") {
            fields = fields.map((field: any) => {
                if (field.name === "independentType") {
                    return { ...field, hidden: false };
                }
                return field;
            });
        }

        if (watcher === "D") {
            fields = fields.map((field: any) => {
                if (field.name === "laborRelationship") {
                    return { ...field, hidden: false };
                }
                return field;
            });
        }

        return { ...section, fields };
    });
    return process;
};
